export const scrollToError = () => {
  // This will select either a field or the warning message
  const firstErrorField = document.querySelector(
    '[aria-invalid=true], form [aria-live=polite]'
  );
  firstErrorField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
